export enum ProcessPublicationType {
  Cancel = 0,
  Republish = 1,
  Publish = 2
}
